import type { StaticDataRouteOption } from "@tanstack/react-router"

import { SettingsNavigation } from "../SettingsNavigation/SettingsNavigation"
import { FormSettingsIdentifiersViewTopBar } from "./TopBar"

export const formSettingsIdentifiersViewStaticData: StaticDataRouteOption = {
	leftSlideOut: SettingsNavigation,
	topBar: FormSettingsIdentifiersViewTopBar,
}
